import styled from 'styled-components';
import { BODY } from 'styles/helpers/typography';
import { prem } from 'styles/helpers/spacing';
import { BREAKPOINTS } from 'styles/constants/devices';

const InstallationTutoModalWrapper = styled.div`
  width: 100%;

  @media (${BREAKPOINTS.M}) {
    width: ${prem(500)};
  }

  p {
    margin: ${prem(20)} 0 0 ${prem(8)};
  }

  // Share icon inlined in the steps and in the notes (Brave fallback)
  .icon-share {
    width: ${prem(20)};
    vertical-align: middle;
  }

  .action {
    margin-top: ${prem(20)};
  }

  .msg-only {
    text-align: center;
    margin: 0 0 ${prem(20)} 0;
    ${BODY.large};
  }

  ul {
    // Browser default is 40px, which pushed the bullets far to the right
    padding-left: ${prem(24)};
    margin: 0 0 ${prem(16)};

    li {
      margin: 0 0 ${prem(4)};
    }
  }
`;

export { InstallationTutoModalWrapper };
